<template>
  <div>
    <div>Current selection has {{ selectedAssets.length }} assets, from which {{ videosCount }} are videos</div>

    <div class="d-flex justify-content-between align-items-end">
      <div>
        <b-form-group :label="`Apply the following rotation to ${videosCount} videos`">
          <b-form-radio-group
              v-model="selectedOption"
              :options="options"
              buttons/>
        </b-form-group>
      </div>

      <div>
        <b-button variant="secondary" @click="$emit('cancel')">Cancel</b-button>
        <b-button variant="primary" :disabled="videosCount === 0 || bulkActionRunning || actionDisabled"
                  @click="handleBulkStatus">
          <pulse-loader v-if="bulkActionRunning"
                        :loading="bulkActionRunning"
                        size="10px"
                        color="#00C0F4"
                        class="mx-2"/>
          <span v-else>Save</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>

import GeneralMixins from "../../../../mixins/GeneralMixins";
import PulseLoader from 'vue-spinner/src/PulseLoader';

export default {
  props: ['selectedAssets', 'idKey'],

  model: {
    prop: 'selectedAssets',
    event: 'change'
  },

  mixins: [GeneralMixins],

  components: {PulseLoader},

  data() {
    return {
      bulkActionRunning: false,
      selectedOption: "90",
      idKeyName: this.idKey || 'id',
      actionDisabled: false,
      options: [
        {text: 'Rotate by 90 deg clockwise', value: '90'},
        {text: 'Rotate by 90 deg counter-clockwise', value: '270'},
      ]
    }
  },

  methods: {

    handleBulkStatus: function () {

      const assetIds = this.videos.map(img => img[this.idKeyName])

      let attributes = {
        asset_ids: assetIds,
        rotation: this.selectedOption
      };

      if (assetIds.length === 0) {
        this.showToast("No videos selected", "Error")
        return
      }

      this.bulkActionRunning = true;

      this.$http.post("/curators/bulk/video_rotations", attributes).then(result => {
        this.showToast("Selected assets have been scheduled for rotation. This will take a while...", "Success")
        this.actionDisabled = true
      }, rejectionResult => {
        this.showErrorToast(null, rejectionResult.body.errors)
      }).then(result => {
        this.bulkActionRunning = false
      });
    },
  },

  computed: {
    videosCount() {
      return this.videos.length
    },

    videos() {
      return this.selectedAssets.filter(asset => asset.type === 'Video')
    }
  }
}
</script>